import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InputDatePickerComponent } from "./input/date-picker/input-date-picker.component";
import { DirectivesModule } from '../../directives/directives.module';
import { NgSelectModule } from "@ng-select/ng-select";
import { PipesModule } from "src/app/pipes/pipes.module";
import { NgxGaugeModule } from "ngx-gauge";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { ValidationModule } from '../validation/shared.module';
import { TooltipComponent } from "./tooltip/tooltip.component";
const maskConfig: Partial<IConfig> = {
    validation: false,
  };
@NgModule({
    imports: [
        // RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        NgSelectModule,
        PipesModule,
        NgxGaugeModule,
        NgxMaskModule.forRoot(maskConfig),
        TooltipModule.forRoot(),
        BsDatepickerModule,
        TabsModule,
        CollapseModule.forRoot(),
        ValidationModule,
    ],
    declarations: [
        InputDatePickerComponent,
        TooltipComponent
    ],
    exports: [
        InputDatePickerComponent,
        TooltipComponent
    ]
})
export class GenericModule { }